import { Avatar, Box, Sheet, Typography, useColorScheme } from "@mui/joy";
import { hatchlingCharacters } from "../../data/hatchlingData";
import HatchlingCharacterName from "./HatchlingCharacterName";

const HatchlingCharacterGallery = () => {
  const { mode } = useColorScheme();
  const isDark = mode === "dark";

  // Ember color for Hatchling
  const emberColor = "rgba(239, 68, 68, 0.8)";

  return (
    <Sheet
      variant="outlined"
      sx={{
        mt: 4,
        p: 3,
        borderRadius: "lg",
        border: "1px solid",
        borderColor: isDark ? "neutral.800" : "neutral.200",
      }}
    >
      <Typography
        level="title-md"
        sx={{
          fontFamily: "'Cinzel', serif",
          textAlign: "center",
          mb: 3,
          color: emberColor,
        }}
      >
        Characters
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          justifyContent: "center",
        }}
      >
        {Object.entries(hatchlingCharacters).map(([id, character]) => (
          <HatchlingCharacterName key={id} id={id} avatarOnly>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
                cursor: "pointer",
                transition: "transform 0.2s",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              <Avatar
                src={character.image}
                alt={character.name}
                sx={{
                  width: 60,
                  height: 60,
                  border: "2px solid",
                  borderColor: isDark ? "danger.600" : "danger.400",
                }}
              >
                {character.name.charAt(0)}
              </Avatar>
              <Typography
                level="body-xs"
                sx={{
                  fontFamily: "'Cinzel', serif",
                  textAlign: "center",
                  maxWidth: 80,
                  color: isDark ? "neutral.300" : "neutral.700",
                }}
              >
                {character.name}
              </Typography>
            </Box>
          </HatchlingCharacterName>
        ))}
      </Box>
    </Sheet>
  );
};

export default HatchlingCharacterGallery;
